/** Display helpers for DNA upload result — honest labels, no guessed providers. */

export const DNA_LOW_MARKER_THRESHOLD = 1000;

const SAMPLE_FILENAME_PATTERN = /(^|[_\-.])(sample|demo|test|fixture|mock|example|sandbox)([_\-.]|\.|$)/i;

const CONFIDENT_SOURCE_LABELS = {
  ancestry: 'AncestryDNA',
  myheritage: 'MyHeritage',
  ftdna: 'FamilyTreeDNA',
  gedmatch: 'GEDmatch',
  other: 'Living DNA / other compatible file',
};

/**
 * @param {string | undefined | null} filename
 */
export function isSampleDnaFilename(filename) {
  return SAMPLE_FILENAME_PATTERN.test(filename || '');
}

/**
 * Human-readable provider for the upload result card.
 * Never infers 23andMe from generic tab-separated raw DNA layout alone.
 *
 * @param {{ source?: string, original_filename?: string, user_selected_source?: string }} profile
 */
export function getDnaProviderDisplayLabel(profile) {
  const filename = profile?.original_filename || '';
  if (isSampleDnaFilename(filename)) {
    return 'Sample / test file';
  }

  const source = (profile?.source || 'unknown').toLowerCase();
  const userSelected = (profile?.user_selected_source || 'unknown').toLowerCase();

  if (source === '23andme') {
    const filenameHas23 = filename.toLowerCase().includes('23andme');
    const userPicked23 = userSelected === '23andme';
    if (userPicked23 || filenameHas23) {
      return '23andMe (legacy file)';
    }
    return 'Other compatible raw DNA file';
  }

  if (CONFIDENT_SOURCE_LABELS[source]) {
    return CONFIDENT_SOURCE_LABELS[source];
  }

  if (source === 'unknown' || !source) {
    return 'Other compatible raw DNA file';
  }

  return 'Unknown provider';
}

/**
 * @param {number | undefined | null} markerCount
 */
export function shouldShowLowMarkerNote(markerCount) {
  return typeof markerCount === 'number' && markerCount >= 0 && markerCount < DNA_LOW_MARKER_THRESHOLD;
}
